import { render, staticRenderFns } from "./FoodWineSettings.vue?vue&type=template&id=1330037a&scoped=true"
import script from "./FoodWineSettings.vue?vue&type=script&lang=js"
export * from "./FoodWineSettings.vue?vue&type=script&lang=js"
import style0 from "./FoodWineSettings.vue?vue&type=style&index=0&id=1330037a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1330037a",
  null
  
)

export default component.exports